import { Rating as MyRating } from 'react-simple-star-rating'

export function Rating({count = 0}) {
  return (
    <div className='App my-4'>
      <MyRating
        initialValue={Number(count) || 0}
        size={23}
        allowFraction={false}
        readonly
      />
    </div>
  )
}
